import script from "./BlockBenefiting.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockBenefiting.vue?vue&type=script&setup=true&lang=js"

import "./BlockBenefiting.vue?vue&type=style&index=0&id=d8ddad74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ddad74"]])

export default __exports__